


export const masaiimage: string = 'https://masaischool.com/img/navbar/logo.svg';
export const recaptchasitekey: string = "6LcL1IYkAAAAAOpjnAkBX46h3M2Z3HS7a6mDBndW";
export const reacptchasecret: string = "6LcL1IYkAAAAANf6T89oYeZtG-RbKeBCjFpXSK61";
export const referAndEarnLink: string = "https://www.masaischool.com/referral/";
export const sprintplanlink: string = "https://lookerstudio.google.com/embed/reporting/eb648c7e-0ebe-4ace-be9f-05f85449c32a/page/QHo9C"
export const gifloader = "https://media.tenor.com/7JONloO2xawAAAAM/loading-screen-loading.gif"
export const batchValues =[
    { value: "1", label: "FT_WEB_20" },
{ value: "2", label: "FT_WEB_21" },
{ value: "3", label: "FT_WEB_22" },
{ value: "4", label: "FT_WEB_23" },
{ value: "5", label: "FT_WEB_24" },
{ value: "6", label: "FT_WEB_25" },
]
export const sectionValues =[
    { value: "1", label: "js101" },
{ value: "2", label: "js211" },
{ value: "3", label: "dsa211" },
{ value: "4", label: "dsa101" },
{ value: "5", label: "dsa421" },
{ value: "6", label: "rct101" },
]
export const NavbarArray  = ["Lectures","Assignments","Quizzes","Tickets"
,"Discussions",
"Notifications",
"Messages",
"Electives",
"Announcements",
"Courses"]
export const NavbarAdminArray  = ["Lectures","Assignments","Quizzes","Tickets"
,"Discussions",
"Notifications",
"Messages",
"Electives",
"Announcements",
"Questions",
"problems"]


export const Categoery = [{id:"4", key:"General",tags:["dsa","coding","ecConnect","csbt"]},
{id:"5",key:"Coding Platform",tags:["javascript","java","html","css","react","redux"]},

{id:"6",key:"CSBT",tags:["english","communication","mockInterview","Mac","speaking"]},
{id:"7",key:"DA",tags:["sql","data-analysis","machineLearning","python"]},
{id:"8",key:"DSA",tags:["recursion","two-pointers","linked-List","sorting","binary-search"]},
{id:"9",key:"Coding",tags:["javascript","java","html","css","react","redux"]},
 {id:"10",key:"Maths",tags:["graphs","number-system","time-distance","integration"]},
 {id:"11",key:"Logic",tags:["aptitude","number-system","time-distance","reasoning"]},
 {id:"12",key:"Scrum",tags:["scrum","stand-up"]}]


export const ButtonValues =["BACK","EDIT","DISCUSSIONS","COPY"]
export const repeactIcon = "https://cdn-icons-png.flaticon.com/512/148/148752.png"




export const BatchListMap= [
    { key:"2",el:"FT-WEB-24"},{key:"3",el:"FT-WEB-25"},
    { key:"4",el:"FT-WEB-26"},{key:"5",el:"FT-WEB-27"},
    { key:"6",el:"FT-DA-17"},{key:"7",el:"FT-DA-18"},
    {key:"8",el:"FT-DA-19"}
]

export const SectionListMap= [
    { key:"2",el:"JS201"},{key:"3",el:"JS301"},
    { key:"4",el:"DSA101"},{key:"5",el:"DSA201"},
    { key:"6",el:"DSA301"},{key:"7",el:"DSA401"},
    {key:"8",el:"JA111"},{key:"9",el:"SB101"},{key:"10",el:"SB201"},
   {key:"11",el:"RCT101"},{key:"12",el:"RCT201"},{key:"14",el:"NEM101"},
   {key:"15",el:"NEM111"},{key:"16",el:"JS101"}
]

export const TypeListMap =[
    {
        "id": "1",
        "el": "Live"
    },
    {
        "id": "2",
        "el": "Video"
    },
    {
        "id": "3",
        "el": "Reading"
    }
]
export const CategoryMap= [
    {
        "id": "2",
        "el": "General"
    },
    {
        "id": "3",
        "el": "Coding Platform"
    },
    {
        "id": "4",
        "el": "CSBT"
    },
    {
        "id": "5",
        "el": " DA"
    },
    {
        "id": "6",
        "el": " DSA"
    },
    {
        "id": "7",
        "el": " Coding"
    },
    {
        "id": "8",
        "el": " Maths"
    },
    {
        "id": "9",
        "el": " Logic"
    },
    {
        "id": "10",
        "el": " Scrum"

    },
    {
        "id": "11",
        "el": "Logic"
    },
    {
        "id": "12",
        "el": "Scrum"
    }
]


export const adminListMap1=[
    {
        "id":"1",
        "el": "Vishal Singh",   
    },
    {
        "id":"2",
        "el": "Tridip Rong"
    }
      
]


